export const ERROR_PAGES = {
  notFound: 'not_found',
  gone: 'gone',
};
